import React from 'react';

function Button( props )
{
  let className = "button";

  if( props.disabled )
  {
    className += " button-disabled";
  }

  if( props.className )
  {
    className += " " + props.className;
  }

  return (

    <button
      className={ className }
      disabled={ props.disabled ? true : false }
      onClick={ () =>
      {
        props.onClick();

      } }
      style={ props.style }>
      { props.children }
    </button>

  );
}
export default Button;
